<script>
import NuttremaOverlaySidebarLink from 'components/ui/overlay/nuttrema-overlay-sidebar-link';
import OverlayPage from 'components/ui/menu/persons/popover-user-menu';

export default {
  name: 'sidebar-link-overlay-usermenu',
  mixins: [NuttremaOverlaySidebarLink],
  props: {
    width: {
      type: String,
      required: false,
      default: '20%',
    },
    minWidth: {
      type: String,
      required: false,
      default: '30em',
    },
    theme: {
      default: 'picture-white-border',
    },
    title: {
      default() {
        return this.$t('label.user_menu');
      },
    },
  },
  components: {
    OverlayPage,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/persons/sidebar-link-overlay-usermenu.vue